// import iPadAir11inchM3 from '../../../assets/apple/iPad/iPadAir11inch(M3).jpeg';
// import iPadAirSpaceGrey from '../../../assets/apple/iPad/iPadAirSpaceGrey.jpeg';
// import iPadAirBlue from '../../../assets/apple/iPad/iPadAirBlue.jpeg';
// import iPadAirPurple from '../../../assets/apple/iPad/iPadAirPurple.jpeg';
// import iPadAirStarlight from '../../../assets/apple/iPad/iPadAirStarlight.jpeg';
// import iPadAirlast from '../../../assets/apple/iPad/iPadAirlast.jpeg';
// import iPadAirlasttxt from '../../../assets/apple/iPad/iPadAirlasttxt.jpeg';
import iPadProM5_1 from '../../../assets/apple/iPad/iPad2026/iPadPro/iPadPro_1.png';
import iPadProM5_2 from '../../../assets/apple/iPad/iPad2026/iPadPro/iPadPro_2.png';
import iPadProM5_3 from '../../../assets/apple/iPad/iPad2026/iPadPro/iPadPro_3.png';
import iPadAirM4_1 from '../../../assets/apple/iPad/iPad2026/iPadAir/iPadAir01.png';
import iPadAirM4_2 from '../../../assets/apple/iPad/iPad2026/iPadAir/iPadAir02.png';
import iPadA16_1 from '../../../assets/apple/iPad/iPad2026/iPadA16/iPadA16All1.png';
import iPadA16_2 from '../../../assets/apple/iPad/iPad2026/iPadA16/iPadA16All2.png';
import iPadA16_3 from '../../../assets/apple/iPad/iPad2026/iPadA16/iPadA16AllSide.png';
import iPadMini7Gen2026 from '../../../assets/apple/iPad/iPad2026/iPadMini/iPadMini7Gen/iPadMini7Gen.png';
import iPadMini7GenGesture2026 from '../../../assets/apple/iPad/iPad2026/iPadMini/iPadMini7Gen/iPadMini7GenGesture.png';

const iPadProM5Images = [
  iPadProM5_1,
  iPadProM5_2,
  iPadProM5_3,
];

const iPadAirM4Images = [
  iPadAirM4_1,
  iPadAirM4_2,
];

const iPadA16Images = [
  iPadA16_1,
  iPadA16_2,
  iPadA16_3,
];

const iPadMini7Gen2026Images = [
  iPadMini7Gen2026,
  iPadMini7GenGesture2026,
];

const iPadProM5CommonSpecifications = {
  'Display & Design': [
    'Ultra Retina XDR OLED display (11-inch) with ProMotion and up to ~1600 nits HDR brightness.',
    'Thin, lightweight aluminium design with edge-to-edge screen and anti-reflective coating.',
    'Available in Space Black and Silver.',
  ],
  'Performance & OS': [
    'Powered by the Apple M5 chip with advanced CPU, GPU, and Neural Engine.',
    'Runs iPadOS 26 with improved multitasking and Apple Pencil features.',
  ],
  Battery: [
    'Up to ~10 hours of web browsing or video playback.',
    'USB-C / Thunderbolt port with fast charging support.',
  ],
  'Camera & Audio': [
    '12 MP rear camera with 4K video recording.',
    '12 MP Ultra-Wide front camera with Center Stage.',
    'Four-speaker audio system with spatial audio.',
  ],
  Connectivity: [
    'Wi-Fi 6E and optional 5G cellular models.',
    'Bluetooth and high-speed USB-C / Thunderbolt connectivity.',
  ],
  Accessories: [
    'Supports Apple Pencil Pro and Apple Magic Keyboard for iPad Pro for drawing, typing, and productivity.',
  ],
};

const iPadAirM4CommonSpecifications = {
  'Display & Design': [
    '11-inch Liquid Retina LCD display with True Tone and wide color (P3).',
    'Thin, lightweight aluminium design with edge-to-edge screen.',
  ],
  'Performance & OS': [
    'Powered by the Apple M4 chip for fast performance and efficient multitasking.',
    'Runs iPadOS 26 with improved multitasking and productivity features.',
  ],
  Battery: [
    'Up to ~10 hours of web browsing or video playback.',
    'USB-C port with fast charging support.',
  ],
  'Camera & Audio': [
    '12 MP rear camera with 4K video recording.',
    '12 MP front camera with Center Stage.',
    'Landscape stereo speakers and dual microphones.',
  ],
  Connectivity: [
    'Wi-Fi 6E and optional 5G cellular models.',
    'Bluetooth and USB-C connectivity for accessories.',
  ],
  Accessories: [
    'Supports Apple Pencil Pro and Apple Magic Keyboard for iPad Air for drawing, note-taking, and productivity.',
  ],
};

const iPadA16CommonSpecifications = {
  'Display & Design': [
    '10.9-inch Liquid Retina display with True Tone and wide color (P3).',
    'Slim aluminium design with an edge-to-edge screen and flat edges.',
  ],
  'Performance & OS': [
    'Powered by the Apple A16 Bionic chip for smooth everyday performance.',
    'Runs iPadOS 26 with improved multitasking and app features.',
  ],
  Battery: [
    'Up to ~10 hours of web browsing or video playback.',
    'USB-C charging and connectivity.',
  ],
  'Camera & Audio': [
    '12 MP rear camera with 4K video recording.',
    '12 MP front camera with Center Stage.',
    'Stereo speakers and dual microphones.',
  ],
  Connectivity: [
    'Wi-Fi 6 and optional 5G cellular models.',
    'Bluetooth and USB-C support for accessories.',
  ],
  Accessories: [
    'Supports Apple Pencil (USB-C) and Apple Magic Keyboard Folio for typing, drawing, and productivity.',
  ],
};

const iPadMini7GenCommonSpecifications = {
  'Display & Design': [
    '8.3-inch Liquid Retina display with True Tone and wide color (P3).',
    'Compact, lightweight aluminium design ideal for portability and one-hand use.',
  ],
  'Performance & OS': [
    'Powered by the Apple A17 Pro chip for fast performance and improved graphics.',
    'Runs iPadOS 26 with enhanced multitasking and Apple Pencil features.',
  ],
  Battery: [
    'Up to ~10 hours of web browsing or video playback.',
    'USB-C charging and connectivity.',
  ],
  'Camera & Audio': [
    '12 MP rear camera with 4K video recording.',
    '12 MP front camera with Center Stage.',
    'Stereo speakers and dual microphones.',
  ],
  Connectivity: [
    'Wi-Fi 6E and optional 5G cellular models.',
    'Bluetooth and USB-C support for accessories.',
  ],
  Accessories: [
    'Supports Apple Pencil Pro for drawing, note-taking, and creative work.',
  ],
};

export const iPadProducts = [
  {
    id: 7,
    title: 'iPad Pro 11inch - M5 256 GB (Wi-Fi)',
    productImage: iPadProM5_1,
    images: iPadProM5Images,
    originalPrice: '1,39,900',
    discountedPrice: '1,39,900',
    colors: ['Space Black', 'Silver'],
    offers: [
      { label: 'Offer', value: ' (Inclusive of credit card offers)' },
      { label: 'EMI', value: ' No Cost EMI Available' },
    ],
    specifications: {
      Variant: [
        'Wi-Fi only',
        '256GB storage',
      ],
      ...iPadProM5CommonSpecifications,
    },
  },
  {
    id: 8,
    title: 'iPad Pro 13inch - M5 256 GB(Wi-Fi)',
    productImage: iPadProM5_1,
    images: iPadProM5Images,
    originalPrice: '1,99,900',
    discountedPrice: '1,99,900',
    colors: ['Space Black', 'Silver'],
    offers: [
      { label: 'Offer', value: ' (Inclusive of credit card offers)' },
      { label: 'EMI', value: ' No Cost EMI Available' },
    ],
    specifications: {
      Variant: [
        'Wi-Fi only',
        '256GB storage',
      ],
      ...iPadProM5CommonSpecifications,
    },
  },
  {
    id: 9,
    title: 'iPad Pro 11inch - M5 256 GB (Wi-Fi + Cellular)',
    productImage: iPadProM5_1,
    images: iPadProM5Images,
    originalPrice: '1,63,900',
    discountedPrice: '1,63,900',
    colors: ['Space Black', 'Silver'],
    offers: [
      { label: 'Offer', value: ' (Inclusive of credit card offers)' },
      { label: 'EMI', value: ' No Cost EMI Available' },
    ],
    specifications: {
      Variant: [
        'Wi-Fi + Cellular',
        '256GB storage',
      ],
      ...iPadProM5CommonSpecifications,
    },
  },
  {
    id: 10,
    title: 'iPad Pro 13inch - M5 256 GB (Wi-Fi + Cellular)',
    productImage: iPadProM5_1,
    images: iPadProM5Images,
    originalPrice: '2,23,900',
    discountedPrice: '2,23,900',
    colors: ['Space Black', 'Silver'],
    offers: [
      { label: 'Offer', value: ' (Inclusive of credit card offers)' },
      { label: 'EMI', value: ' No Cost EMI Available' },
    ],
    specifications: {
      Variant: [
        'Wi-Fi + Cellular',
        '256GB storage',
      ],
      ...iPadProM5CommonSpecifications,
    },
  },
  {
    id: 11,
    title: 'iPad Air 11inch - M4 128 GB (Wi-Fi)',
    productImage: iPadAirM4_1,
    images: iPadAirM4Images,
    originalPrice: '89,900',
    discountedPrice: '89,900',
    colors: ['Space Grey', 'Silver', 'Purple', 'Starlight'],
    offers: [
      { label: 'Offer', value: ' (Inclusive of credit card offers)' },
      { label: 'EMI', value: ' No Cost EMI Available' },
    ],
    specifications: {
      Variant: [
        'Wi-Fi only',
        '128GB storage',
      ],
      ...iPadAirM4CommonSpecifications,
    },
  },
  {
    id: 12,
    title: 'iPad Air 13inch - M4 128 GB (Wi-Fi)',
    productImage: iPadAirM4_1,
    images: iPadAirM4Images,
    originalPrice: '1,19,900',
    discountedPrice: '1,19,900',
    colors: ['Space Grey', 'Silver', 'Purple', 'Starlight'],
    offers: [
      { label: 'Offer', value: ' (Inclusive of credit card offers)' },
      { label: 'EMI', value: ' No Cost EMI Available' },
    ],
    specifications: {
      Variant: [
        'Wi-Fi only',
        '128GB storage',
      ],
      ...iPadAirM4CommonSpecifications,
    },
  },
  {
    id: 13,
    title: 'iPad Air 11inch - M4 128 GB (Wi-Fi + Cellular)',
    productImage: iPadAirM4_1,
    images: iPadAirM4Images,
    originalPrice: '1,07,900',
    discountedPrice: '1,07,900',
    colors: ['Space Grey', 'Silver', 'Purple', 'Starlight'],
    offers: [
      { label: 'Offer', value: ' (Inclusive of credit card offers)' },
      { label: 'EMI', value: ' No Cost EMI Available' },
    ],
    specifications: {
      Variant: [
        'Wi-Fi + Cellular',
        '256GB storage',
      ],
      ...iPadAirM4CommonSpecifications,
    },
  },
  {
    id: 14,
    title: 'iPad Air 13inch - M4 128 GB (Wi-Fi + Cellular)',
    productImage: iPadAirM4_1,
    images: iPadAirM4Images,
    originalPrice: '1,37,900',
    discountedPrice: '1,37,900',
    colors: ['Space Grey', 'Silver', 'Purple', 'Starlight'],
    offers: [
      { label: 'Offer', value: ' (Inclusive of credit card offers)' },
      { label: 'EMI', value: ' No Cost EMI Available' },
    ],
    specifications: {
      Variant: [
        'Wi-Fi + Cellular',
        '256GB storage',
      ],
      ...iPadAirM4CommonSpecifications,
    },
  },
  {
    id: 15,
    title: 'iPad A16 (Wi-Fi 128GB)',
    productImage: iPadA16_1,
    images: iPadA16Images,
    originalPrice: '49,900',
    discountedPrice: '49,900',
    colors: ['Blue', 'Silver', 'Pink', 'Yellow'],
    offers: [
      { label: 'Offer', value: ' (Inclusive of credit card offers)' },
      { label: 'EMI', value: ' No Cost EMI Available' },
    ],
    specifications: {
      Variant: [
        'Wi-Fi only',
        '128GB storage',
      ],
      ...iPadA16CommonSpecifications,
    },
  },
  {
    id: 16,
    title: 'iPad A16 (Wi-Fi 256GB)',
    productImage: iPadA16_1,
    images: iPadA16Images,
    originalPrice: '61,900',
    discountedPrice: '61,900',
    colors: ['Blue', 'Silver', 'Pink', 'Yellow'],
    offers: [
      { label: 'Offer', value: ' (Inclusive of credit card offers)' },
      { label: 'EMI', value: ' No Cost EMI Available' },
    ],
    specifications: {
      Variant: [
        'Wi-Fi only',
        '256GB storage',
      ],
      ...iPadA16CommonSpecifications,
    },
  },
  {
    id: 17,
    title: 'iPad Mini 7 Gen (Wi-Fi 128GB)',
    productImage: iPadMini7Gen2026,
    images: iPadMini7Gen2026Images,
    originalPrice: '69,900',
    discountedPrice: '69,900',
    colors: ['Purple', 'Space Grey', 'Blue', 'Starlight'],
    offers: [
      { label: 'Offer', value: ' (Inclusive of credit card offers)' },
      { label: 'EMI', value: ' No Cost EMI Available' },
    ],
    specifications: {
      Variant: [
        'Wi-Fi only',
        '128GB storage',
      ],
      ...iPadMini7GenCommonSpecifications,
    },
  },
].sort((a, b) => b.id - a.id);
